import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class RecurringInvoiceHistoryService {

  constructor(private dataService: DataService) { }

  getInvoiceBatchReportData(searchQuery: any) {

    return this.dataService.post('/api/RecurringInvoiceHistory/getInvoiceBatchReportData', searchQuery);
  }

  getBillingReportDetails() {

    return this.dataService.getRecord('/api/RecurringInvoiceHistory/getBillingReportDetails');
  }
  getBillingReportDetailsForDateSearch(searchQuery: string) {
    return this.dataService.getRecordWithParams('/api/RecurringInvoiceHistory/getBillingReportDetailsForDateSearch', searchQuery);
  }
  getBillingDetailsForFilterSearch(searchQuery: string) {

    return this.dataService.getRecordWithParams('/api/RecurringInvoiceHistory/getBillingDetailsForFilterSearch', searchQuery);
  }
}
